<template>
  <Fade :delay="0" :duration="300">
    <div v-if="construction" class="preloader row middle-xs">
      <div class="center col-xs-7 col-sm-5 col-md-3 logo">
        <LandingLogo
          :options="defaultOptions"
          v-on:animCreated="handleAnimation"
        />
        <h1>W O M P!</h1>
        <h1>This site is still under construction. Please check back soon</h1>
      </div>
    </div>
  </Fade>
</template>

<script>
import LandingLogo from "@/transitions/LandingLogo.vue";
import Fade from "@/transitions/Fade.vue";
import * as animationData from "../assets/Logo_White.json";
export default {
  name: "Construction",
  components: {
    LandingLogo,
    Fade
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default }
    };
  },
  props: {
    construction: Boolean
  },
  mounted() {
    let Vue = this;
    window.onload = function() {
      Vue.$emit("windowReady");
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
      anim.loop = true;
      anim.setSpeed(0.85);
      anim.play();
    }
  }
};
</script>

<style lang="scss" scoped>
// * {
//   border: 1px solid red;
// }

.preloader {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: $brand-blue;
  z-index: 9999;
  overflow: hidden;
  justify-content: center;

  h1 {
    margin-top: 1rem;
    text-align: center;
    overflow: none;
    color: $off-white;
    // font-family: $text-font-stack;
    font-weight: 400;
    // display: block;
    &:first-child {
      font-family: $text-font-stack;
    }
  }
}
.logo > svg {
  max-height: 33vh;
}
</style>
